import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import 'swiper/css/navigation';

export default function productSlider() {
    let productSlider = document.querySelector('.product-slider__slider');

    if (!productSlider) return;

    const swiper = new Swiper('.product-slider__slider', {
      slidesPerView: 1,
      spaceBetween: 23,
      speed: 1300,
      grabCursor: true,
      modules: [Navigation],
      navigation: {
        nextEl: '.product-slider__next',
        prevEl: '.product-slider__prev',
        },
        breakpoints: {
            375: {
                slidesPerView: 1,
                  },
              580: {
                slidesPerView: 2,
              },
          768: {
            slidesPerView: 'auto',
          },
		  },
    });
}